import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./LoginPage'))

export default new AsyncPage({
  isChromeless: true,
  basicDataRequirements: {
    instance: true,
    session: false
  },
  pageComponent: component
})
